import { Box, IconButton, Typography, Divider, Tabs, Tab, CircularProgress } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import DriversLocations from "../../Components/Dispatcher/DriversLocations";
import OrdersLocations from "../../Components/Dispatcher/OrdersLocations";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useOrderContext } from "contexts/OrderContext";
import { useRTL } from "hooks/isRTL";
import { getDriverLocations } from "services/order";

const DispatchPage = () => {
  const { driverLocations, orderDetails } = useOrderContext();
  const { t } = useRTL();
  const [currentDriver, setCurrentDriver] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const navigate = useNavigate();
  const [drivers, setDrivers] = useState([]);
  const [loadingDrivers, setLoadingDrivers] = useState(false);

  // Fetch drivers from backend per activeTab (isActive flag)
  useEffect(() => {
    const fetchDrivers = async () => {
      if (!orderDetails?.pickUpLocation?.coordinates) {
        setDrivers([]);
        return;
      }

      setLoadingDrivers(true);
      try {
        const mappedOrderType = orderDetails?.type === 2 ? 2 : 1; // keep existing mapping if needed
        const isActive = activeTab === 0; // tab 0 = active drivers
        console.log("Fetching drivers with isActive:", isActive, "orderType:", mappedOrderType);
        const res = await getDriverLocations(
          20,
          1,
          orderDetails.pickUpLocation.coordinates.latitude,
          orderDetails.pickUpLocation.coordinates.longitude,
          mappedOrderType,
          isActive
        );

        console.log("Driver locations full response:", res);
        // API returns data structure; normalize to an array of locations
        // Try multiple possible response shapes: res.data.page, res.page, res.data, res directly
        const list = res?.data?.page || res?.page || res?.data || res || [];
        console.log("Normalized driver list:", list, "Total count:", Array.isArray(list) ? list.length : "not an array");
        setDrivers(Array.isArray(list) ? list : []);
      } catch (err) {
        console.error("Failed to fetch driver locations:", err);
        setDrivers([]);
      } finally {
        setLoadingDrivers(false);
      }
    };

    fetchDrivers();
  }, [activeTab, orderDetails]);

  const displayedDrivers = drivers || [];

  useEffect(() => {
    if (displayedDrivers && displayedDrivers.length > 0) {
      setCurrentDriver(displayedDrivers[0]);
    } else {
      setCurrentDriver(null);
    }
  }, [displayedDrivers]);

  return (
    <Box
      sx={{
        display: "flex",
        padding:
          document.documentElement.dir === "rtl"
            ? "1rem 6rem 0rem 1rem"
            : "1rem 1rem 0rem 6rem",
        gap: "2rem",
        height: "90vh",
      }}
    >
      <Box
        sx={{
          flex: "0 0 25%",
          display: "flex",
          flexDirection: "column",
          borderRadius: "8px",
          overflowY: "auto",
          backgroundColor: "white",
          padding: "1rem",
          position: "relative",
          height: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "0.5rem",
            marginBottom: "1rem",
          }}
        >
          <IconButton
            onClick={() => navigate(-1)}
            sx={{
              padding: 0,
            }}
          >
            <ArrowBack fontSize="medium" />
          </IconButton>
          <Typography
            variant="h2"
            sx={{
              fontWeight: "bold",
              color: "text.primary",
            }}
          >
            {t("availableDrivers")}
          </Typography>
        </Box>
        <Divider />

        {/* Tabs for Active/Inactive */}
        <Tabs value={activeTab} onChange={(e, newValue) => setActiveTab(newValue)} sx={{ marginBottom: "1rem" }}>
          <Tab label="Active Drivers" />
          <Tab label="Inactive Drivers" />
        </Tabs>

        {loadingDrivers ? (
          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
            <CircularProgress />
          </Box>
        ) : displayedDrivers.length === 0 ? (
          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%", flexDirection: "column" }}>
            <Typography color="text.secondary" sx={{ marginBottom: "1rem" }}>
              No {activeTab === 0 ? "active" : "inactive"} drivers available
            </Typography>
          </Box>
        ) : (
          <DriversLocations
            drivers={displayedDrivers}
            currentDriver={currentDriver}
            setCurrentDriver={setCurrentDriver}
          />
        )}
      </Box>

      <Box
        sx={{
          flex: "0 0 60%",
          backgroundColor: "#ffffff",
          borderRadius: "8px",
          height: "85vh",
        }}
      >
        <OrdersLocations currentDriver={currentDriver} />
      </Box>
    </Box>
  );
};

export default DispatchPage;
